<template>
  <div v-if="component">
    <PowerApp :id="component.general.uuid" v-if="isCustomTemplate"  :entrypoint="templateEntrypoint" />
    <DefaultList :component="component" v-else />

    <protokol-floating-settings v-if="$can('settings ' + this.component.general.name) && $isPlatformEnv('dev')">
      <b-button variant="dark" to="settings" :append="true">{{ $t('settings') }}</b-button>
      <b-button variant="dark" to="settings#workflow" :append="true">{{ $t('workflow.title') }}</b-button>
      <b-button variant="dark" v-bind="editorButtonProps" >
        <span class="editorText">{{ $t('editor') }}</span>
      </b-button>
    </protokol-floating-settings>

  </div>
  <b-skeleton width="100%" height="250px" class="align-middle" animation="throb" v-else/>
</template>

<style scoped>
.controls {
  position: relative;
  padding-bottom: 20px;
}

.controls .btn {
  margin-right: 10px;
}
</style>

<script>
import DefaultList from './DefaultList'

export default {
  components: {
    PowerApp: () => import('./ComponentView'),
    DefaultList
  },
  data: () => {
    return {
      component: null,
      showSidebar: false
    }
  },

  computed: {
    editorButtonProps() {
      let props = {
        to: `/component/editor/${this.$route.meta.ref}?v=${this.component.settings.version}`,
        target: "_blank"
      }

      return props
    },

    isCustomTemplate() {
            return this.templateEntrypoint != ''
        },

        templateEntrypoint() {
            if (this.entrypoint == 'default') return ''
            if (this.entrypoint) return this.entrypoint

            return this.component.settings.appearance.list_entrypoint
        }
  },

  async created() {
    this.component = await this.$store.dispatch("fetchComponentsSettings", this.$route.meta.ref)

    if (!this.$can("read " + this.component.general.name)) {
        this.$bvToast.toast(this.$t('noPermissionsToRead'), {
          title: this.$t('error'),
          variant: 'danger'
        })
        return
    }
  }
}
</script>
